import { usePcpLiveLessonContext } from "../store";
import { useMemo } from "react";

/**
 * Make calls to the Pcp Web API using
 * - the correctly defined endpoint URL
 * - the current user's token
 */
export function usePcpApi() {
    const apiDelete = usePcpLiveLessonContext(s => s.apiDelete);
    const apiPost = usePcpLiveLessonContext(s => s.apiPost);
    const apiGet = usePcpLiveLessonContext(s => s.apiGet);
    const apiPostProgress = usePcpLiveLessonContext(s => s.apiPostProgress);

    return useMemo(
        () => ({
            delete: apiDelete,
            post: apiPost,
            get: apiGet,
            postProgress: apiPostProgress,
        }),
        [apiDelete, apiPost, apiGet, apiPostProgress]
    );
}

export const usePcpApiMethods = () => {
    const pcpApi = usePcpApi();

    return useMemo(() => ({
        deleteMessage: (threadId: string, messageId: string, fromUserId: string) =>
            pcpApi.delete(`/api/live-lesson/chat/delete-message`, { threadId, messageId, fromUserId }),

        clearChat: (threadId: string) =>
            pcpApi.delete(`/api/live-lesson/chat/clear-chat`, { threadId }),

        removeParticipant: (lessonId: string, participantId: string) =>
            pcpApi.delete(`/api/live-lesson/${lessonId}/users/${participantId}`),
    }), [pcpApi]);
};
